import React from 'react';
import { Navigate, useLocation } from 'react-router-dom';
import { useSelector } from 'react-redux';
import { Box, CircularProgress } from '@mui/material';

const PrivateRoute = ({ children }) => {
  const location = useLocation();
  const { isAuthenticated, loading } = useSelector((state) => state.auth);

  // Show loading spinner while checking authentication
  if (loading) {
    return (
      <Box sx={{ display: 'flex', justifyContent: 'center', alignItems: 'center', minHeight: '100vh' }}>
        <CircularProgress />
      </Box>
    );
  }

  // If not authenticated, redirect to login
  if (!isAuthenticated) {
    return <Navigate to="/login" state={{ from: location }} replace />;
  }

  // For now, allow any authenticated user
  // TODO: Add role-based access control when user profile loading is implemented
  // const hasAdminRole = user?.roles?.some(
  //   (role) => role === 'Admin' || role === 'SuperAdmin'
  // );
  // if (!hasAdminRole) {
  //   return <Navigate to="/unauthorized" replace />;
  // }

  return children;
};

export default PrivateRoute;

